import { UPQuestionAssessmentResponse } from 'up';

export interface QuestionAssessmentState {
  questionAssessmentInfo: UPQuestionAssessmentResponse[];
}

export const initialQuestionAssessmentState: QuestionAssessmentState = {
  questionAssessmentInfo: [],
};
